import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "@msuite/ui/utils";
import { Can } from "@/components/citadel/can";
import { AddTourWaveModal } from "@/modals/stock/add-tour-wave-modal";

export function TourWavesMenu() {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const disclosure = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Can
				action="create"
				subject="Stock"
			>
				<Button
					icon={<Icon name="Plus" />}
					variant="primary"
					onClick={disclosure.onOpen}
				>
					{t("stock.add_tour_wave")}
				</Button>
			</Can>
			{disclosure.isOpen && (
				<AddTourWaveModal
					isOpen={disclosure.isOpen}
					onClose={disclosure.onClose}
					onComplete={refetch}
				/>
			)}
		</Fragment>
	);
}
